import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { BrandsService } from '../../services/system/brands.service';
import { tap, takeUntil, Subject } from 'rxjs';
import { Brands } from '../../models/brands';
import { IResponse } from '../../models/iresponse';

@Component({
  selector: 'app-services-dropdown',
  templateUrl: './services-dropdown.component.html',
  styleUrl: './services-dropdown.component.scss'
})
export class ServicesDropdownComponent {

  _unsubscribe$: Subject<boolean> = new Subject()
  @Input() label: string = 'Common.ServiceName'
  @Input() isRequired:boolean = false
  @Output() setSelected: EventEmitter<any> = new EventEmitter();
  @Output() setSelectedBrandData: EventEmitter<any> = new EventEmitter();
  //Filter Variables
  brandList: Brands[] = [];


  form: FormGroup = this.fb.group({
    brandId: new FormControl(""),
  });;

  constructor(
    private fb: FormBuilder,
    private brandService: BrandsService
  ) { }


  reset() {
    this.form.reset()
    this.setSelected.emit("")
    this.setSelectedBrandData.emit(null)
  }

  ngOnInit() {
    this.GetBrands();
    if(this.isRequired){
      this.form.get('brandId')?.addValidators(Validators.required)
    }
  }


  GetBrands() {
    return this.brandService.GetBrands()
      .pipe(
        tap(
          (result: IResponse<Brands>) => {
            this.brandList = result.Data;
          }
        ),
        takeUntil(this._unsubscribe$),
      )
      .subscribe();
  }

  onClick() {
    let selected = this.form.get('brandId')?.value
    let index = this.brandList.findIndex(i=>i.Id==this.form.get('brandId')?.value)
    this.setSelected.emit(selected)
    this.setSelectedBrandData.emit(index>=0 ? this.brandList[index] : null)
  }

  
  ngOnDestroy(): void {
      this._unsubscribe$.next(true)
      this._unsubscribe$.complete()
    }
}
